import { apiClient, apiClientAuth } from "../config/httpClient";


export function MessageApi(contentType = "application/json")
{
    const http = apiClient(contentType);
    // const https = apiClientAuth(contentType);

    return {

        insert : (data) => http.post("/api/message", data),

        // findOne: (id) => https.get(`/api/message/${id}`),

        // findAll: () => https.get(`/api/message`),


      };
}

